<template>
  <div class="fe-input">
    <el-form-item
      :label="endTitle | capitalize"
      :class="{ 'form-group--error': $v.defaultValue.$error, 'is-required': isRequired }"
    >
      <el-input
        :placeholder="placeholder"
        :prefix-icon="icon"
        v-model="defaultValue"
        @focus="showDialog()"
        @blur="triggerVaildate"
        class="fe-input-content fe-input-dia"
        suffix-icon="el-icon-tickets"
        :readonly="true"
        :title="tips"
        ref="input"
      >
        <i v-if="clearable && defaultValue" class="el-icon-error"  slot="append" @click.stop.prevent="clear"></i>
      </el-input>
       <div
        class="el-form-item__error error_input"
        v-if="inForm && $v.defaultValue.$error"
      >{{errorMessage}}
      </div>
    </el-form-item>
  </div>
</template>
<script>
  import validateMixin from '../../mixins/validateMixin'
  import baseMixin from './mixin/base'
  export default {
    name: 'fe-inputDia',
    mixins: [validateMixin, baseMixin],
    props: {
      configKey: {
        type: String
      },
      formData: {
        type: Boolean
      },
      showBack: {
        type: Boolean,
        default: true
      },
      clearable: {
        type: Boolean,
        default: false
      },
      target: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    data() {
      return {
        defaultValue: '',
        tips: '',
        values: [],
        storageData: [],
        orderUser: new Date().getTime() + this.configKey,
        radioOrCheckbox: '',
        textValues: [],
        backValues: [] // 回显
      }
    },
    watch: {
      defaultValue(val) {
        if (this.radioOrCheckbox === 'radio') {
          this.$emit('input', this.storageData.length ? this.storageData[0][this.storageData[this.storageData.length - 1].returnValue] : '')
        } else if (this.radioOrCheckbox === 'checkbox') {
          this.values = []
          this.$emit('input', (() => {
            this.storageData.length !== 0 && this.storageData[0].map((item, index) => {
              this.values.push(item[this.storageData[this.storageData.length - 1].returnValue])
            })
            return this.values
          })())
        }
      }
    },
    created() {
      this.$eventBus.$on('edit', (data) => {
        if (this.formData) {
          for (var i = 0; i < this.textValues.length; i++) {
            if (this.textValues[i].value) {
              if (this.name === this.textValues[i].value.value) {
                this.defaultValue = data[this.textValues[i].value.textValue]
              }
            }
          }
          this.tips = data.roleNames
        }
      })
      this.$eventBus.$on('textValue', (data) => {
        this.textValues = data
      })
      this.$eventBus.$on(this.orderUser, (data, type) => {
        this.defaultValue = {}
        this.backValues = []
        if (this.configKey === localStorage.getItem('inputType')) {
          this.storageData = data
          this.backValues = data[0]
          var len = data.length
          this.radioOrCheckbox = type
          if (this.radioOrCheckbox === 'radio') {
            this.defaultValue = ''
            this.emitBackValues(data[0])
            const radioValue = data[0][data[len - 1].returnDisplay]
            this.defaultValue = radioValue.indexOf('null') === -1 ? radioValue : radioValue.substring(0, radioValue.indexOf('null'))
          } else if (this.radioOrCheckbox === 'checkbox') {
            this.tips = ''
            const returnDisplay = data[len - 1].returnDisplay
            this.defaultValue = ''
            data[0].map((item, index) => {
              var isHasNull = item[returnDisplay].indexOf('null')
              // if (index === 0) {
              //   console.log(333)
              //   this.defaultValue = data[0].length !== 1 ? isHasNull === -1 ? item[returnDisplay] : item[returnDisplay].substring(0, isHasNull) + '...' : isHasNull === -1 ? item[returnDisplay] : item[returnDisplay].substring(0, isHasNull)
              // } else {
              if (isHasNull === -1) {
                this.tips += data[0].length !== 1 ? item[returnDisplay] + ((index === data[0].length - 1) ? '' : ',') : item[returnDisplay]
                this.defaultValue += data[0].length !== 1 ? item[returnDisplay] + ((index === data[0].length - 1) ? '' : ',') : item[returnDisplay]
              } else {
                this.tips += data[0].length !== 1 ? item[returnDisplay].substring(0, isHasNull) + ((index === data[0].length - 1) ? '' : ',') : item[returnDisplay].substring(0, isHasNull)
                this.defaultValue += data[0].length !== 1 ? item[returnDisplay].substring(0, isHasNull) + ((index === data[0].length - 1) ? '' : ',') : item[returnDisplay].substring(0, isHasNull)
              }
              // }
            })
          }
          localStorage.removeItem('inputType')
        }
      })
      this.$eventBus.$on('clearDefaultValueDia', () => {
        this.defaultValue = ''
        this.storageData = []
      })
    },
    methods: {
      clear() {
        this.storageData = []
        this.defaultValue = ''
        this.$emit('input', '')
        this.emitBackValues({})
        // if (this.radioOrCheckbox === 'radio') {
        //   this.value = ''
        // } else if (this.radioOrCheckbox === 'checkbox') {
        //   this.storageData = []
        // }
      },
      // 触发回显带出来的数据
      emitBackValues(data) {
        if (this.target && this.target.length > 0) {
          this.target.forEach((key) => {
            this.$bus.$emit(this.code + '-backValues-' + key, data[key] || '')
          })
        }
      },
      showDialog() {
        const that = this
        const checkedData = []
        if (this.radioOrCheckbox === 'checkbox') {
          this.$eventBus.$emit('checkoutbox', this.backValues)
          if (this.showBack) {
            const codeName = Array.isArray(this.defaultValue) ? this.defaultValue : this.defaultValue.split(',');
            if (codeName.length === this.value.length) {
              this.value.forEach((data, i) => {
                checkedData.push([that.value[i], codeName[i] || ''])
              })
            } else {
              console.error('返回的code 和 name 不匹配')
            }
          }
        } else if (this.showBack) {
          // checkedData.push([that.value, that.defaultValue])
        }
        // console.error(checkedData)
        setTimeout(() => {
          const formData = this.$parent.$props.model
          that.$eventBus.$emit('searchDialogShow', that.configKey, that.orderUser, that.value, checkedData, formData)
          localStorage.setItem('inputType', that.configKey)
        }, 200)
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .form-group--error{
    .el-form-item__content{
      .el-input__inner{
        border-color: #F08047!important;
      }
      .fe-input-content, .fe-select-content, .fe-single-data-picker-input-content, .fe-double-data-picker-input-content, .fe-text-content{
        .el-input__inner, .el-textarea__inner{
          border-color: #F08047!important;
        }
      }
    }
  }
  .error_input{
    width: 178px;
  }
  .fe-input {
    width: unset;
    margin-top: 5px;
    margin-bottom: 5px;
    .el-form-item {
      margin-bottom: 0px !important;
      &.s-required{
        &::before{
           content: "*";
           color: #f56c6c;
           margin-right: 4px;
           position: absolute;
           bottom: 5px;
           left:0;
         }
      }
    }
    label {
      font-size: 12px;
      width: 100px;
      line-height: 30px;
      display: inline-block;
    }

    .fe-input-content {
      width: 178px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/FromBase/inputDia.vue